export class ConfiguracoesViagem {

    motivo: string
    meioTransporte: string
    tipo: string
    origem: number
    destino: number
    totalPassageiros: string
    esporteRadicalViagem: boolean
    motocicletaViagem: boolean
    visitaEuropa: boolean
    idade: string

    constructor() {
        this.motivo = null;
        this.meioTransporte = null;
        this.tipo = null;
        this.origem = null;
        this.destino = null;
        this.totalPassageiros = null;
        this.esporteRadicalViagem = false;
        this.motocicletaViagem = false;
        this.visitaEuropa = false;
        this.idade = null;
    }
}